declare namespace $ {

	export class $shm_hitalama_guide_drag extends $shm_hitalama_dragtree {
		catalog( ): $shm_hitalama_guide_catalog
		locked( ): boolean
		drag_hold_delay( ): number
		drag_touch_action( ): string
		drop_root_gutter( ): boolean
		drop_folder_edges( ): boolean
	}
	
}

//# sourceMappingURL=drag.view.tree.d.ts.map